import React from "react";
import { TextField } from "@material-ui/core";
import { getPointerEventsStyles, getReadOnlyStyles } from "../../lib/styles";

export function NumberInput({ fieldConfig, controllerField, fieldState }) {
  const { readOnly, preserveExact } = fieldConfig;
  const { value, onChange, ...rest } = controllerField;

  const handleChange = (e) => {
    // preserveExact keeps the raw typed string ("2.0") instead of coercing
    // to a Number — trailing zeros are significant for measurements and
    // Number("2.0") would collapse them to 2. The backend column must be
    // numeric/text for the precision to survive storage.
    if (preserveExact) {
      onChange(e.target.value === "" ? null : e.target.value);
      return;
    }
    const numericValue = e.target.valueAsNumber;
    onChange(isNaN(numericValue) ? null : numericValue);
  };

  const displayValue =
    value !== null && value !== undefined && !isNaN(value)
      ? value.toString()
      : "";

  return (
    <TextField
      {...rest}
      value={displayValue}
      disabled={readOnly}
      onChange={handleChange}
      variant="outlined"
      size="small"
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      style={getReadOnlyStyles(readOnly)}
      InputProps={{
        style: getPointerEventsStyles(readOnly),
        type: "number",
      }}
      fullWidth
    />
  );
}
